import * as qs from 'query-string';

import { GetSessionResponse } from '@src/api/delivery-checkout';
import { apiUtils, authFetch } from '@src/utils';

export const getSession = async (
  siteId: string,
  checkoutSessionId: string,
  privateKey: string
): Promise<GetSessionResponse> => {
  const options = {
    method: 'GET',
    headers: {
      'x-site-id': siteId,
      Authorization: `Bearer ${btoa(privateKey)}`,
    },
  };

  return authFetch<GetSessionResponse>(
    `${apiUtils.getApiUrl()}/delivery_checkout/session.get?${qs.stringify({
      checkout_session_id: checkoutSessionId,
    })}`,
    options
  );
};
